import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { ApiKey } from 'src/features/apiKeys/utils/types';
import UpdateApiKeyFormModal from 'src/features/apiKeys/components/forms/UpdateApiKeyFormModal';
import { apiKeysMessages } from 'src/features/apiKeys/utils/apiKeysMessages';
import DeleteApiKeyFormModal from 'src/features/apiKeys/components/forms/DeleteApiKeyFormModal';

export default function CellApiKeyActions({ row }: CellContext<ApiKey, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateApiKeyFormModal
                        selectedApiKey={row.original}
                        semantics={{ entryName: formatMessage(apiKeysMessages.apiKey).toLowerCase() }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateApiKeyFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteApiKeyFormModal
                        selectedApiKey={row.original}
                        semantics={{ entryName: formatMessage(apiKeysMessages.apiKey).toLowerCase() }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteApiKeyFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
